import { __awaiter } from "tslib";
import { logger } from '@lusha/client-logger';
import AjaxUtils from './ajaxUtils';
const sendClientMetric = (metrics, isSuccessfullyParsed) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        AjaxUtils.post('/api/v3/monitor-manager', { metrics, isSuccessfullyParsed });
    }
    catch (err) {
        logger.error('Failed to send client metrics', { err });
    }
});
export { sendClientMetric };
